import { Service } from '@toeverything/infra';

import type { WorkspaceMetadata } from '../metadata';
import type { LocalEraseOptions } from '../providers/flavour';
import type { WorkspaceFlavoursService } from './flavours';

export class WorkspaceDestroyService extends Service {
  constructor(private readonly flavoursService: WorkspaceFlavoursService) {
    super();
  }

  deleteWorkspace = async (metadata: WorkspaceMetadata) => {
    return this.provider(metadata).deleteWorkspace(metadata.id);
  };

  eraseLocalData = async (
    metadata: WorkspaceMetadata,
    options?: LocalEraseOptions
  ) => {
    const provider = this.provider(metadata);
    if (!provider.eraseLocalData)
      throw new Error(`No local erase for flavour: ${metadata.flavour}`);
    return provider.eraseLocalData(metadata.id, options);
  };

  private provider(metadata: WorkspaceMetadata) {
    const provider = this.flavoursService.flavours$.value.find(
      p => p.flavour === metadata.flavour
    );
    if (!provider) {
      throw new Error(`Unknown workspace flavour: ${metadata.flavour}`);
    }
    return provider;
  }
}
